<template>
<div class="chapter">
<div class="inner_page">
<p class="partnum">Part I</p>
<p class="parttit">THE HISTORY</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Part1.vue?615c5bef